module.exports = {
    init: () => {
        const takeTutorialButtonClass = ".take_tutorial";
        const takeTutorialButton      = document.querySelector(takeTutorialButtonClass);
        const doneButtonClass         = ".tutorial__buttons__done";
        const doneButtons             = document.querySelectorAll(doneButtonClass);
        const nextButtonsClass        = ".tutorial__buttons__next";
        const nextButtons             = document.querySelectorAll(nextButtonsClass);
        const backButtonsClass        = ".tutorial__buttons__back";
        const backButtons             = document.querySelectorAll(backButtonsClass);
        const urlParams               = new URLSearchParams(window.location.search);
        const tutorialParam           = urlParams.get("tutorial");
        if (tutorialParam) {
            runTutorial();
        }
        takeTutorialButton.onclick = () => {
            runTutorial();
        };
        function activateStep1 () {
            const step2Window = document.querySelector(".step1");
            step2Window.classList.add("tutorial--active");
            const phasesHeader = document.querySelector(".process_map__phases");
            phasesHeader.classList.add("tutorial_theme");
            setTimeout(() => window.scrollTo(0, 0), 150);
        }
        function actvateStep2 () {
            // add active class to step 2 and highlight first lane
            const step2Window = document.querySelector(".step2");
            step2Window.classList.add("tutorial--active");
            const firstLane = document.querySelector(".process_map__lane");
            firstLane.classList.add("tutorial_theme");
            // activate the second lane
            const targetLane = document.querySelectorAll(".process_map__lane__line")[0];
            targetLane.classList.add("process_map__lane__line--active");
            window.scrollTo(0, 150);
        }
        function activateStep3 () {
            // add active class to step 3
            const step3Window = document.querySelector(".step3");
            step3Window.classList.add("tutorial--active");
            window.scrollTo(0, 420);
            // activate the second lane
            const targetLane = document.querySelectorAll(".process_map__lane__line")[1];
            targetLane.classList.add("process_map__lane__line--active");
            const targetNode = document.querySelector("button[data-definition-id=node_61]");
            targetNode.classList.add("process_map__lane__sub_lane__toggle--active");
            const targetDefinition = document.querySelector("li[data-definition-id=node_61]");
            targetDefinition.classList.add("process_map__definitions__item--active");
            targetDefinition.parentNode.parentNode.classList.add("process_map__definitions--is_visible");
        }
        function deactivateStep3 () {
            // remove current active tutorial
            const activeTutorial = document.querySelector(".step3");
            activeTutorial.classList.remove("tutorial--active");
            // deactivate highlighted definition
            const targetDefinition = document.querySelector("li[data-definition-id=node_61]");
            targetDefinition.parentNode.parentNode.classList.remove("process_map__definitions--is_visible");
            targetDefinition.classList.remove("process_map__definitions__item--active");
            // deactivate highlighted lane
            const targetLane = document.querySelectorAll(".process_map__lane__line")[1];
            targetLane.classList.remove("process_map__lane__line--active");
            // doneButtons[i].parentNode.parentNode.parentNode.classList.remove("tutorial--active");
            window.scrollTo(0, 0);
        }
        function deactivateStep1 () {
            // remove current active tutorial
            const activeTutorial = document.querySelector(".tutorial--active");
            if (activeTutorial) {
                activeTutorial.classList.remove("tutorial--active");
            }
            const activeThemes = document.querySelectorAll(".tutorial_theme");
            if (activeThemes) {
                for (let i = 0; i < activeThemes.length; i++) {
                    activeThemes[i].classList.remove("tutorial_theme");
                }
            }
        }
        function deactivateStep2 () {
            // remove current active tutorial
            const activeTutorial = document.querySelector(".tutorial--active");
            if (activeTutorial) {
                activeTutorial.classList.remove("tutorial--active");
            }
            const activeThemes = document.querySelectorAll(".tutorial_theme");
            for (let i = 0; i < activeThemes.length; i++) {
                activeThemes[i].classList.remove("tutorial_theme");
            }
            // deactivate highlighted lane
            const targetLane = document.querySelectorAll(".process_map__lane__line")[0];
            targetLane.classList.remove("process_map__lane__line--active");
        }
        // function that runs tutorial functionality
        function runTutorial () {
            activateStep1();
            // action for next and done buttons
            // for all Next buttons
            for (let i = 0; i < nextButtons.length; i++) {
                // if next button belong to step 1
                if (nextButtons[i].parentNode.parentNode.parentNode.classList.contains("step1")) {
                    nextButtons[i].onclick = () => {
                        deactivateStep1();
                        actvateStep2();
                    };
                }
                // if next button belong to step 2
                if (nextButtons[i].parentNode.parentNode.parentNode.classList.contains("step2")) {
                    nextButtons[i].onclick = () => {
                        deactivateStep2();
                        activateStep3();
                    };
                }
            }
            // for all Back buttons
            for (let i = 0; i < backButtons.length; i++) {
                // if back button belong to step 2
                if (backButtons[i].parentNode.parentNode.parentNode.classList.contains("step2")) {
                    backButtons[i].onclick = () => {
                        deactivateStep2();
                        activateStep1();
                    };
                }
                // if back button belong to step 3
                if (backButtons[i].parentNode.parentNode.parentNode.classList.contains("step3")) {
                    backButtons[i].onclick = () => {
                        deactivateStep3();
                        actvateStep2();
                    };
                }
            }
            // for all Done buttons
            for (let i = 0; i < doneButtons.length; i++) {
                // remove current tutorial window on clicking Done button
                doneButtons[i].onclick = () => {
                    if (doneButtons[i].parentNode.parentNode.parentNode.classList.contains("step1")) {
                        deactivateStep1();
                    }
                    if (doneButtons[i].parentNode.parentNode.parentNode.classList.contains("step2")) {
                        deactivateStep2();
                    }
                    if (doneButtons[i].parentNode.parentNode.parentNode.classList.contains("step3")) {
                        deactivateStep3();
                    }
                };
            };
        }
        if (document.querySelector(".tutorial--active")) {
            runTutorial();
        }
    }
};
